import type { AtpcoFigures, FareComponentSummary, RefundQuoteData, SearchCheck } from './types'

/**
 * The fare-rules endpoint's contribution to the refund payload (GET /bookings/:id/fare-rules).
 * Fetched separately from tickets-check and merged client-side.
 */
export interface FareRulesPayload {
  fareRules?: FareComponentSummary[]
  fareRulesError?: boolean
  atpco?: AtpcoFigures
  /** The flat fields bm-api sent before `atpco`. Read only while an older bm-api is still deployed. */
  atcoPenaltyFee?: number
  atcoNonRefundableTaxes?: number
  refundAdminFee?: number
  refundAdminFeeSource?: string
  penaltyToBookingCurrencyRate?: number
  searchCheck?: SearchCheck
}

/**
 * THE merge of the two live endpoints into one RefundQuoteData. Refunds.tsx and the fixture
 * tooling both use this, so a captured fixture is byte-equivalent to what the UI computes from —
 * never a hand-rolled approximation.
 */
export function mergeRefundQuotePayload(ticketsCheck: RefundQuoteData, fareRules?: FareRulesPayload): RefundQuoteData {
  if (!fareRules) return ticketsCheck
  return {
    ...ticketsCheck,
    fareRules: fareRules.fareRules,
    fareRulesError: fareRules.fareRulesError,
    atpco: fareRules.atpco ?? {
      penaltyFee: fareRules.atcoPenaltyFee,
      nonRefundableTaxes: fareRules.atcoNonRefundableTaxes,
    },
    refundAdminFee: fareRules.refundAdminFee,
    refundAdminFeeSource: fareRules.refundAdminFeeSource,
    penaltyToBookingCurrencyRate: fareRules.penaltyToBookingCurrencyRate,
    searchCheck: fareRules.searchCheck,
  }
}
